import React from 'react';
import PropTypes from 'prop-types';

import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Label, ReferenceLine, Cell } from 'recharts';
import Tick from 'components/charts/Tick';
import HatchedBarWithStroke from 'components/charts/HatchedBarWithStroke';

const OvernightBarChart = (props) => {
    const { data, bars, xAxisKey, yAxisLabel, yAxisTickFormatter, tooltip } = props;

    const renderBar = (type) => (
        <Bar
            key={type}
            name={type}
            barSize={60}
            stackId="overnightStackId"
            dataKey={(row) => row.accessors[type](row)}
            isAnimationActive={false}
            shape={<HatchedBarWithStroke hatched={type === 'nonGuaranteed'} />}
        >
            {data.map((row) => (
                <Cell key={`${type}-${row.title}`} fill={row.colours[type]} />
            ))}
        </Bar>
    );

    return (
        <ResponsiveContainer height={270} width="100%">
            <BarChart data={data}>
                {bars.map(renderBar)}

                <XAxis
                    interval={0}
                    tickMargin={15}
                    axisLine={false}
                    tickLine={false}
                    dataKey={xAxisKey}
                    tick={<Tick fontSize={15} />}
                />
                <YAxis
                    // Ensures a small margin around min & max values
                    domain={['dataMin - 3', 'dataMax + 3']}
                    width={45}
                    tickLine={false}
                    allowDecimals={false}
                    tick={<Tick formatter={yAxisTickFormatter} />}
                >
                    <Label value={yAxisLabel} position="insideLeft" angle={-90} style={{ textAnchor: 'middle' }} />
                </YAxis>

                <ReferenceLine y={0} stroke="black" />
                <Tooltip filterNull={false} isAnimationActive={false} content={tooltip} cursor={false} />
            </BarChart>
        </ResponsiveContainer>
    );
};

OvernightBarChart.propTypes = {
    bars: PropTypes.arrayOf(PropTypes.string).isRequired, // types of bars
    data: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            accessors: PropTypes.shape({
                guaranteed: PropTypes.func,
                nonGuaranteed: PropTypes.func,
            }).isRequired,
            colours: PropTypes.shape({
                guaranteed: PropTypes.string,
                nonGuaranteed: PropTypes.string,
            }).isRequired,
            rooms: PropTypes.shape({
                guaranteed: PropTypes.number,
                nonGuaranteed: PropTypes.number,
            }),
        }),
    ).isRequired,
    xAxisKey: PropTypes.string.isRequired,
    yAxisLabel: PropTypes.string.isRequired,
    yAxisTickFormatter: PropTypes.func.isRequired,
    tooltip: PropTypes.element.isRequired,
};

export default OvernightBarChart;
